import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { mapApiEmitterTypeToLabel } from './mapApiEmitterTypeToLabel'

export const makeNameEmitterTypeLabel = ({
  name,
  emitterType,
}: {
  name: string
  emitterType: TEmitterType
}) => {
  return `${name} (${mapApiEmitterTypeToLabel(emitterType)})`
}
